const engineeringRouter = [
  // 工程能力看板
  {
    path: 'engineering-capability',
    name: 'EngineeringCapability',
    component: () => import('@/views/wxapp/bulletin-board/engineering'),
    meta: {
      title: '工程'
    },
    children: [
      {
        path: 'engineering-capability-home',
        name: 'EngineeringCapabilityHome',
        component: () => import('@/views/wxapp/bulletin-board/engineering/engineering-capability/home'),
        meta: {
          title: '工程能力'
        }
      },
      {
        path: 'engineering-capability-home-subject',
        name: 'EngineeringCapabilityHomeSubject',
        component: () => import('@/views/wxapp/bulletin-board/engineering/engineering-capability/home/subject'),
        meta: {
          title: '工程能力'
        }
      }
    ]
  }

]
export default engineeringRouter
